export const SET_WAREHOUSE = "SET_WAREHOUSE";
export const SET_WAREHOUSES = "SET_WAREHOUSES";
